'use client';

import rte from '@/utils/rte';

const VariantButtonsModal = ({ modalDoc }) => {
  if (!modalDoc) return null;

  const html = rte(modalDoc);
  if (!html) return null;

  return (
    <div
      className="rte-content rte-content--light px-6 py-10 sm:px-8 sm:py-12 lg:px-10 lg:py-8 text-center font-worksans text-base leading-relaxed text-primary [&_h2]:[font-family:var(--font-cormorant)] [&_h2]:font-normal [&_p]:mb-4 [&_p:last-child]:mb-0"
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
};

export default VariantButtonsModal;
